import React from 'react';

import Image from 'next/image';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import imageService from '@services/utils/ImageService';

import css from './Choice.module.scss';

type ChoiceProps = {
    email: string;
    selected: boolean;
    revivedCount?: number;
    invited?: boolean;
    customClass?: string;
    onClick: () => void;
};

const Choice = ({ email, selected, onClick, revivedCount, customClass, invited }: ChoiceProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <div
            onClick={() => {
                onClick();
            }}
            className={`${css.choice__revive} ${customClass || ''}`}
        >
            <Text customClass={css.choice__revive__email} variant={'caption_02'} color={'txt-primary'}>
                {email}
            </Text>
            <div className={css.choice__revive__second_block}>
                {revivedCount > 0 && (
                    <Text customClass={css.choice__revive__revived} variant={'caption_02'} color={'ui-success'}>
                        {t('settings.revives.already-revived', { count: revivedCount })}
                    </Text>
                )}
                {invited && (
                    <Text customClass={css.choice__revive__invited} variant={'caption_02'} color={'ui-success'}>
                        {t('settings.invites.already-invited')}
                    </Text>
                )}
                <div className={css.choice__revive__icon}>
                    {selected ? (
                        <Image
                            loader={imageService.customImageLoader}
                            width={24}
                            height={24}
                            src={'/front-static/icons/display/checkmark-outline-primary.svg'}
                            alt={'checkmark'}
                        />
                    ) : (
                        <div className={css.choice__revive__not_selected} />
                    )}
                </div>
            </div>
        </div>
    );
};
export default Choice;
